import { classifyWebecwError, withWebecwHttpRequestMetrics } from "@/src/lib/ehr/ecw/webecw/observability";
import { stats } from "@/src/lib/logging/stats.server";

export async function withEcwMetric<T>(
  operation: string,
  tags: Record<string, string>,
  fn: () => Promise<T>
): Promise<T> {
  const start = performance.now();

  try {
    const result = await fn();

    stats.timer(`ecw.${operation}.duration_ms`, performance.now() - start, { tags: { ...tags, outcome: "success" } });
    stats.counter(`ecw.${operation}.completed`, 1, { tags: { ...tags, outcome: "success" } });

    return result;
  } catch (error) {
    const { errorType, httpStatus, responseBodyKind, sessionReason } = classifyWebecwError(error);
    const errorTags = {
      ...tags,
      errorType,
      outcome: "failure",
      ...(httpStatus === undefined ? {} : { httpStatus: String(httpStatus) }),
      ...(responseBodyKind ? { responseBodyKind } : {}),
      ...(sessionReason ? { sessionReason } : {}),
    };

    stats.timer(`ecw.${operation}.duration_ms`, performance.now() - start, { tags: errorTags });
    stats.counter(`ecw.${operation}.completed`, 1, { tags: errorTags, error });

    throw error;
  }
}

export function withEcwRequestMetric<T>(
  context: { groupId: string; method: string; path: string },
  fn: () => Promise<T>
): Promise<T> {
  return withEcwMetric("request", context, () => withWebecwHttpRequestMetrics(context, fn));
}
